import copy from "../../public/locales/en/analytics.json";

import type { CampaignAttributionRow } from "@lingoshade/domain";

const countries = new Intl.DisplayNames("en", { type: "region" });

export function countryName(country: string | null): string {
  return country
    ? (countries.of(country) ?? country)
    : copy.campaign.unknownCountry;
}

export function analyticsRatio(value: number | null): string {
  return value === null
    ? copy.campaign.noData
    : new Intl.NumberFormat("en", {
        style: "percent",
        maximumFractionDigits: 1,
      }).format(value);
}

export function campaignRowsForCountry(
  rows: CampaignAttributionRow[],
  country: string,
): CampaignAttributionRow[] {
  const grouped = new Map<string, CampaignAttributionRow>();
  for (const row of rows) {
    if (country !== "all" && (row.country ?? "") !== country) continue;
    const key = JSON.stringify([
      row.source,
      row.medium,
      row.campaign,
      row.content,
      row.referrerHost,
    ]);
    const entry = grouped.get(key) ?? {
      ...row,
      visits: 0,
      registrations: 0,
      practicedRegistrations: 0,
      paidRegistrations: 0,
    };
    entry.visits += row.visits;
    entry.registrations += row.registrations;
    entry.practicedRegistrations += row.practicedRegistrations;
    entry.paidRegistrations += row.paidRegistrations;
    grouped.set(key, entry);
  }
  return Array.from(grouped.values())
    .map((row) => ({
      ...row,
      registrationToVisitRatio: null,
      paymentRate:
        row.registrations > 0
          ? row.paidRegistrations / row.registrations
          : null,
      activationRate:
        row.registrations > 0
          ? row.practicedRegistrations / row.registrations
          : null,
    }))
    .sort((a, b) => b.visits - a.visits || b.registrations - a.registrations);
}
